<template>
    <div class="page_home_about flex-col">
        <div class="group_about flex-col">
            <div class="group_8 flex-row">
                <div class="block_92 flex-col justify-between">
                    <div class="box_8 flex-row">
                        <span class="text_12">关于我们</span>
                        <span class="text_13">About&nbsp;us</span>
                    </div>

                    <span class="text_14">
            康柏汉森深耕医药行业近二十年，是大健康领域风险控制服务的倡导者与实践者。依托现有的全国10大运营中心，资深项目经理与执行团队以及企业健康管理智慧中心等服务优势，为大健康领域100余家全球领先企业提供全链路风控与合规管理服务。
            <br />
            <br />
            康柏汉森专注于企业业务风险诊断与合规管理，深刻理解企业经营健康与业务成长的迫切需求，为企业提供业务风控与合规管理的多样化产品以及整体服务解决方案，助力客户达成“风险可视、决策可依、增长可持续”。
          </span>


                </div>
                <div class="box_about_img_wrap">
                    <div class="box_about_img_inner">
                        <div class="box_about_img flex-col" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeAbout",
        props: {
            imageUrl: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                isActiveIndex: 0, // 用于跟踪当前激活的菜单项索引
            }
        },
        mounted() {

        },
        methods: {
            goto(item){
                if(item && item.id){
                    let url = "Outsourcing_info?id=" + item.id;
                    this.$router.push(url);
                }
            },
            handleMouseOver(index) {
                this.isActiveIndex = index;
            },
            handleMouseOut(index) {
                if (this.isActiveIndex === index) {
                    this.isActiveIndex = null;
                }
            },
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped >
    .group_about {
        width: 1468px;
    }

    .group_8 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 6px;
        position: relative;
        width: 1468px;
        height: 305px;
    }

    .block_92 {
        width: 945px;
        height: 238px;
        margin: 37px 0 0 389px;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-col {
         display: flex;
         flex-direction: column;
     }

    .box_8 {
        background-color: rgba(255, 255, 255, 0);
        width: 945px;
    }
    .box_8.flex-row {
        display: flex;
        flex-direction: row;
    }

    .text_12 {
        width: 104px;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(30, 30, 30, 1);
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 37px;
        margin-left: 88px;
    }

    .text_13 {
        width: 111px;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(204, 204, 204, 1);
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 37px;
        margin: 0 623px 0 19px;
    }

    .text_14 {
        width: 857px;
        height: 182px;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 18px;

        text-align: justify;
        line-height: 26px;
        margin-left: 88px;
    }

    .box_about_img_wrap {
        width: 313px;
        height: 226px;
        left: 134px;
        top: 37px;
        position: absolute;
        overflow: hidden;
    }
    .box_about_img_inner {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .box_about_img {

        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        overflow: hidden;
        transition: transform 0.3s ease;
        transform-origin: center center;
        transform-box: border-box;

    }
    .box_about_img:hover {
        transform: scale(1.2);
    }

</style>
